import { Logo } from './Logo.js';

/** Masa kodları sabit: iki masa var, ikisi de her zaman aynı yerde. */
export const TABLES = [
  { code: 'M1', name: 'MASA 1' },
  { code: 'M2', name: 'MASA 2' },
] as const;

export interface TableStatus {
  /** Masada oturanların adları. */
  players: string[];
  /** Maç sürüyorsa yeni oyuncu alınmıyor. */
  playing: boolean;
}

export function Lobby({
  name,
  tables,
  canResume,
  onSit,
  onBots,
  onResume,
}: {
  name: string;
  tables: Partial<Record<string, TableStatus>>;
  /** Yarım kalmış bir bot maçı var mı. */
  canResume: boolean;
  onSit(code: string): void;
  onBots(): void;
  onResume(): void;
}) {
  return (
    <div className="home">
      <Logo />
      <h1>Üç Beş Sekiz</h1>

      <div className="tables">
        {TABLES.map((table) => {
          const status = tables[table.code];
          const players = status?.players ?? [];
          const full = players.length >= 3 || status?.playing === true;

          return (
            <button
              key={table.code}
              type="button"
              className="table-card"
              onClick={() => onSit(table.code)}
              disabled={full}
            >
              <span className="table-card__name">{table.name}</span>
              {/* Üç koltuk, üç nokta: dolu olanlar baş harfle. Sayı yazmak
                  yerine koltukları göstermek masanın hâlini bir bakışta veriyor. */}
              <span className="table-card__seats">
                {[0, 1, 2].map((i) => {
                  const who = players[i];
                  return (
                    <span
                      key={i}
                      className={`table-card__seat ${who ? 'is-full' : ''}`}
                      title={who ?? 'boş'}
                    >
                      {who ? who.slice(0, 1).toUpperCase() : ''}
                    </span>
                  );
                })}
              </span>
              <span className="table-card__count">
                {status?.playing ? 'oyun sürüyor' : `${players.length}/3`}
              </span>
            </button>
          );
        })}
      </div>

      <div className="home__actions">
        {/* Devam eden maç varsa ÖNCE o: uygulama arka planda kapanmış olabilir
            ve oyuncu tam da kaldığı yeri arıyordur. */}
        {canResume && (
          <button
            type="button"
            className="btn btn--primary btn--pill btn--big"
            onClick={onResume}
          >
            Devam et
          </button>
        )}
        <button type="button" className="btn btn--pill btn--big" onClick={onBots}>
          {canResume ? 'Yeni oyun' : 'Botlarla oyna'}
        </button>
      </div>

      <span className="field">
        <span>{name}</span>
      </span>
    </div>
  );
}
